import { useEffect } from "react";
import { useLocation } from "wouter";
import { LoginScreen } from "../../auth/components/LoginScreen";
import { LandingPage } from "./LandingPage";
import { ReleasesPage } from "./ReleasesPage";
import { LegalPage, PrivacyPage } from "./LegalPage";
import { RoadmapPage } from "./RoadmapPage";
import { NotFoundPage } from "./NotFoundPage";
import { AuthNav } from "./AuthNav";
import { usePublicTheme } from "../hooks/usePublicTheme";
import { isKnownAppRoute } from "../../../shared/types/view-routes";
import { track } from "../../../lib/analytics";
import { isNative } from "../../../lib/capacitor";

interface PublicRouterProps {
  readonly onLogin: () => void;
}

export function PublicRouter({ onLogin }: PublicRouterProps) {
  const [location] = useLocation();
  const { isDark, toggle } = usePublicTheme();

  useEffect(() => {
    const page = location === "/login" ? "login" as const
      : location === "/register" ? "register" as const
      : location === "/releases" ? "releases" as const
      : "landing" as const;
    track("public_page_viewed", { page });
  }, [location]);

  if (location === "/login" || location === "/register") {
    return (
      <>
        <AuthNav isDark={isDark} onToggleTheme={toggle} />
        <LoginScreen
          onLogin={onLogin}
          initialMode={location === "/register" ? "register" : "login"}
        />
      </>
    );
  }

  if (location === "/releases") {
    return <ReleasesPage isDark={isDark} onToggleTheme={toggle} />;
  }

  if (location === "/legal") {
    return <LegalPage isDark={isDark} onToggleTheme={toggle} />;
  }

  if (location === "/privacy") {
    return <PrivacyPage isDark={isDark} onToggleTheme={toggle} />;
  }

  if (location === "/roadmap") {
    return <RoadmapPage isDark={isDark} onToggleTheme={toggle} />;
  }

  if (location === "/" || location === "" || isKnownAppRoute(location)) {
    // En natif (Capacitor), pas de landing — directement login
    if (isNative) {
      return (
        <>
          <AuthNav isDark={isDark} onToggleTheme={toggle} />
          <LoginScreen onLogin={onLogin} initialMode="login" />
        </>
      );
    }
    return <LandingPage isDark={isDark} onToggleTheme={toggle} />;
  }

  return <NotFoundPage isDark={isDark} onToggleTheme={toggle} />;
}
